import classNames from "classnames";

export type PricingHeroHeadingType = {
  text: string;
  highlight?: boolean;
  lineBreak?: boolean;
}[];

type PricingHeroHeadingPropsType = {
  heading: PricingHeroHeadingType;
  isComparePlans?: boolean;
};

const PricingHeroHeading = ({ heading, isComparePlans = false }: PricingHeroHeadingPropsType) => {
  if (heading?.length > 0)
    return (
      <h1
        className={classNames(
          "font-Inter text-[#393F41] align-middle",
          isComparePlans 
            ? "text-title-32 sm:font-bold sm:text-[64px] sm:leading-[72px] sm:tracking-normal"
            : "font-bold sm:font-semibold text-[56px] sm:text-[64px] leading-[72px] tracking-normal"
        )}
      >
        {heading.map(({ text, highlight, lineBreak }, idx) => {
          return (
            <span key={idx}>
              {highlight ? <span className="text-purple-3">{text}</span> : text}
              {lineBreak && <br />}
            </span>
          );
        })}
      </h1>
    );
  else return null;
};

export default PricingHeroHeading;
